import { getAddresses } from "./addressBook";

export const NIGER_CITIES = [
  { key: "niamey", name: "Niamey", lat: 13.5116, lng: 2.1254 },
  { key: "agadez", name: "Agadez", lat: 16.9733, lng: 7.9911 },
  { key: "diffa", name: "Diffa", lat: 13.3154, lng: 12.6113 },
  { key: "dosso", name: "Dosso", lat: 13.049, lng: 3.194 },
  { key: "maradi", name: "Maradi", lat: 13.5, lng: 7.1017 },
  { key: "tahoua", name: "Tahoua", lat: 14.8888, lng: 5.2692 },
  { key: "tillaberi", name: "Tillaberi", lat: 14.2071, lng: 1.4531 },
  { key: "zinder", name: "Zinder", lat: 13.8053, lng: 8.9881 },
];

const aliasMap = Object.fromEntries(
  NIGER_CITIES.flatMap((city) => [
    [city.key, city.key],
    [city.name.toLowerCase(), city.key],
  ])
);

const toRad = (value) => (value * Math.PI) / 180;

const haversineKm = (left, right) => {
  const earthRadius = 6371;
  const deltaLat = toRad(right.lat - left.lat);
  const deltaLng = toRad(right.lng - left.lng);
  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(toRad(left.lat)) *
      Math.cos(toRad(right.lat)) *
      Math.sin(deltaLng / 2) ** 2;
  return 2 * earthRadius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const normalizeNigerCity = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";
  const matchedAlias = Object.keys(aliasMap).find((alias) => raw.includes(alias));
  return matchedAlias ? aliasMap[matchedAlias] : "";
};

export const getNigerCityByKey = (key) =>
  NIGER_CITIES.find((city) => city.key === key) || null;

export const getProductCityKey = (product) =>
  normalizeNigerCity(product?.location || product?.city || "");

export const getUserPreferredCityKey = () => {
  const addresses = getAddresses();
  const primaryAddress =
    addresses.find((address) => address.is_default) || addresses[0];
  return normalizeNigerCity(primaryAddress?.city || primaryAddress?.region || "");
};

export const sortProductsByNearestCity = (products, referenceCityKey) => {
  if (!referenceCityKey) return [...products];
  const referenceCity = getNigerCityByKey(referenceCityKey);
  if (!referenceCity) return [...products];

  return [...products].sort((left, right) => {
    const leftCity = getNigerCityByKey(getProductCityKey(left));
    const rightCity = getNigerCityByKey(getProductCityKey(right));
    const leftDistance = leftCity
      ? haversineKm(referenceCity, leftCity)
      : Number.POSITIVE_INFINITY;
    const rightDistance = rightCity
      ? haversineKm(referenceCity, rightCity)
      : Number.POSITIVE_INFINITY;

    if (leftDistance === rightDistance) {
      return (left.name || "").localeCompare(right.name || "");
    }
    return leftDistance - rightDistance;
  });
};

export const filterProductsByCity = (products, cityKey) => {
  if (!cityKey) return [...products];
  return products.filter((product) => getProductCityKey(product) === cityKey);
};
